<div class="result-recommendation-item">
  <span>0{{data.index}}</span>
  <p [innerHTML]="data.text | safeHtml: 'html'">
  </p>
</div>
